import { useEffect, useState } from 'react'
import PdfPage1 from '../PdfPage1/PdfPage1'
import PdfPage2 from '../PdfPage2/PdfPage2'
import PdfPage3 from '../PdfPage3/PdfPage3'
import PdfPage4 from '../PdfPage4/PdfPage4'
import PdfPage5 from '../PdfPage5/PdfPage5'
import PdfPage6 from '../PdfPage6/PdfPage6'
import PdfPage7 from '../PdfPage7/PdfPage7'
import PdfPage8 from '../PdfPage8/PdfPage8'
import PdfPage9 from '../PdfPage9/PdfPage9'
import PdfPage10 from '../PdfPage10/PdfPage10'
// import PdfPage11 from '../PdfPage11/PdfPage11'

function OverallPdfPage(props: {
  project: ProjectModels.ProjectDetail
  onRendered: (cnt: number) => void
  baseNo: number
}) {
  const [cnt, setCnt] = useState(0)

  const changeCnt = (c: number) => {
    setCnt((prev) => prev + c)
  }

  useEffect(() => {
    props.onRendered(cnt)
  }, [cnt])

  return (
    <>
      <PdfPage1
        no={props.baseNo + 1}
        project={props.project}
        onRendered={() => {
          changeCnt(1)
        }}
      />
      <PdfPage2 no={props.baseNo + 2} project={props.project} onRendered={changeCnt} />
      <PdfPage3 no={props.baseNo + 3} project={props.project} onRendered={changeCnt} />
      <PdfPage4 no={props.baseNo + 4} project={props.project} onRendered={changeCnt} />
      <PdfPage5 no={props.baseNo + 5} project={props.project} onRendered={changeCnt} />
      <PdfPage6 no={props.baseNo + 6} project={props.project} onRendered={changeCnt} />
      <PdfPage7 no={props.baseNo + 7} project={props.project} onRendered={changeCnt} />
      <PdfPage8 no={props.baseNo + 8} project={props.project} onRendered={changeCnt} />
      <PdfPage9 no={props.baseNo + 9} project={props.project} onRendered={changeCnt} />
      <PdfPage10 no={props.baseNo + 10} project={props.project} onRendered={changeCnt} />
    </>
  )
}

export default OverallPdfPage
